
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Playground, Props } from 'docz'
import Button from './button'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "button"
    }}>{`Button`}</h1>
    <p><strong parentName="p">{`SUBCATEGORY:`}</strong>{` Buttons`}</p>
    <hr />
    <h2 {...{
      "id": "button-1"
    }}>{`Button`}</h2>
    <h3 {...{
      "id": "description"
    }}>{`Description`}</h3>
    <p>{`For the principle action.`}</p>
    <Playground __position={1} __code={'<Button>Button</Button>\n<Button disabled>Button</Button>\n<Button icon>\n  <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\">\n    <path d=\"M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z\" />\n  </svg>\n</Button>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Button
    }} style={{
      paddingRight: '50%',
      display: 'flex',
      justifyContent: 'space-evenly'
    }} mdxType="Playground">
    <Button mdxType="Button">Button</Button>
    <Button disabled mdxType="Button">Button</Button>
    <Button icon mdxType="Button">
        <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24'>
           <path d='M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z' />
         </svg>
    </Button>
    </Playground>
    <hr />
    <h2 {...{
      "id": "button-inverse"
    }}>{`Button (inverse)`}</h2>
    <h3 {...{
      "id": "description-1"
    }}>{`Description`}</h3>
    <p>{`For the principle action.`}</p>
    <Playground __position={3} __code={'<Button inverse>Button</Button>\n<Button inverse disabled>\n  Button\n</Button>\n<Button inverse icon>\n  <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\">\n    <path d=\"M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z\" />\n  </svg>\n</Button>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Button
    }} style={{
      backgroundColor: "#333",
      margin: '-2em',
      padding: '2em 50% 2em 2em',
      display: 'flex',
      justifyContent: 'space-evenly'
    }} mdxType="Playground">
  <Button inverse mdxType="Button">Button</Button>
  <Button inverse disabled mdxType="Button">Button</Button>
  <Button inverse icon mdxType="Button">
      <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24'>
         <path d='M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z' />
       </svg>
  </Button>
    </Playground>
    <hr />
    <h2 {...{
      "id": "button-secondary"
    }}>{`Button (secondary)`}</h2>
    <h3 {...{
      "id": "description-2"
    }}>{`Description`}</h3>
    <p>{`For secondary actions, and for additional options adjacent to a primary button.`}</p>
    <Playground __position={5} __code={'<Button secondary>Button</Button>\n<Button secondary disabled>\n  Button\n</Button>\n<Button secondary icon>\n  <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\">\n    <path d=\"M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z\" />\n  </svg>\n</Button>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Button
    }} style={{
      paddingRight: '50%',
      display: 'flex',
      justifyContent: 'space-evenly'
    }} mdxType="Playground">
  <Button secondary mdxType="Button">Button</Button>
  <Button secondary disabled mdxType="Button">Button</Button>
  <Button secondary icon mdxType="Button">
      <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24'>
         <path d='M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z' />
       </svg>
  </Button>
    </Playground>
    <hr />
    <h2 {...{
      "id": "button-inverse-secondary"
    }}>{`Button (inverse, secondary)`}</h2>
    <h3 {...{
      "id": "description-3"
    }}>{`Description`}</h3>
    <p>{`For secondary actions, and for additional options adjacent to a primary button.`}</p>
    <Playground __position={7} __code={'<Button inverse secondary>\n  Button\n</Button>\n<Button inverse secondary disabled>\n  Button\n</Button>\n<Button inverse secondary icon>\n  <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\">\n    <path d=\"M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z\" />\n  </svg>\n</Button>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Button
    }} style={{
      backgroundColor: "#333",
      margin: '-2em',
      padding: '2em 50% 2em 2em',
      display: 'flex',
      justifyContent: 'space-evenly'
    }} mdxType="Playground">
  <Button inverse secondary mdxType="Button">Button</Button>
  <Button inverse secondary disabled mdxType="Button">Button</Button>
  <Button inverse secondary icon mdxType="Button">
      <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24'>
         <path d='M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z' />
       </svg>
  </Button>
    </Playground>
    <hr />
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <Props of={Button} mdxType="Props" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;